export function iconCategoryCssClass(sportId, categoryId, iconClass) {
	let cssClass = `icoCategory${sportId}-${categoryId}`;
    if (iconClass?.length > 0) {
        cssClass += ` cms-setted-category-${iconClass}`;
    }
	return cssClass;
}
